import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'hash', 'Hash', [["path",{"d":"M5 9l14 0"}],["path",{"d":"M5 15l14 0"}],["path",{"d":"M11 4l-4 16"}],["path",{"d":"M17 4l-4 16"}]]);